import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SysTypeDocument } from '../models/models'; // Adjust path as needed
import api from './api';

interface SysTypeDocumentState {
  sysTypeData: SysTypeDocument[];
  selectedTypeDoc: SysTypeDocument | null;
  loading: boolean;
  error: string | null;
}

const initialState: SysTypeDocumentState = {
  sysTypeData: [],
  selectedTypeDoc: null,
  loading: false,
  error: null,
};

// Fetch all sys_type_document entries
export const fetchSysTypeDocuments = createAsyncThunk<
  { data: SysTypeDocument[] },
  void,
  { rejectValue: string }
>('sysTypeDocument/fetchAll', async (_, thunkAPI) => {
  try {
    const response = await api.get('/sys_type_document'); // Adjust the endpoint as needed
    return response.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.error || error.response?.data?.message || 'Failed to fetch documents.');
  }
});

const sysTypeDocumentSlice = createSlice({
  name: 'sysTypeDocument',
  initialState,
  reducers: {
    clearSysTypeDocumentError: (state) => {
      state.error = null;
    },
    setSelectedTypeDoc: (state, action) => {
      state.selectedTypeDoc = action.payload;
    },
    clearSelectedTypeDoc: (state) => {
      state.selectedTypeDoc = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSysTypeDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSysTypeDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.sysTypeData = action.payload.data;
      })
      .addCase(fetchSysTypeDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Unknown error';
      });
  },
});

export const {
  clearSysTypeDocumentError,
  setSelectedTypeDoc,
  clearSelectedTypeDoc,
} = sysTypeDocumentSlice.actions;

export default sysTypeDocumentSlice.reducer;
